// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 图片列表 GET /picture_library/List */
export async function getPictureLibraryList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPictureLibraryListParams,
  options?: { [key: string]: any },
) {
  return request<API.PictureLibrary[]>('/picture_library/List', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
